<template>
    <QueueDisplay :total="count">
        <template v-slot:icon>
            <RackOutlineIcon />
        </template>
    </QueueDisplay>
</template>

<script>
import QueueDisplay from "@/components/ui/QueueDisplay.vue"
import RackOutlineIcon from '@/components/customIcons/RackOutlineIcon.vue'
import { onMounted, onUnmounted, ref, watch } from 'vue'
import api from '@/api'

export default {
    components:{QueueDisplay,RackOutlineIcon},
    emits:['count'],
    setup(props, { emit }) {
        const count = ref(0)

    // Watchers
        watch(count, (value) => emit('count', Number(value) || 0), { immediate: true })

        onMounted(()=>{
            getInitialCount()
            joinRoom()
            window.addEventListener('socket_connected', handleReconnect);
            window.addEventListener("rack_queue", handleWebSocketData);
        })

        onUnmounted(()=>{
            window.removeEventListener("socket_connected", handleReconnect);
            window.removeEventListener("rack_queue",handleWebSocketData)
        })

        const handleWebSocketData = (e)=>{
            const data = Number(e.detail?.data)
            if (isNaN(data)) {
                count.value = 0;
            } else {
                count.value = data
            }
        }

        const joinRoom = ()=>{
            let eventJoin = new CustomEvent("requestRoom", {detail: { route: "rack", room: "rack_queue" }});
            dispatchEvent(eventJoin);
        }

        const handleReconnect = ()=>{
            joinRoom()
        }

        const getInitialCount = async ()=>{
            await api
            .get("racks/openCount")
            .then((res)=>{
                res.data?.data && Number(res.data.data) ? count.value = Number(res.data.data) : null
            })
            .catch((err)=>{
                console.error(err.response?.data?.error || err.message)
            })
        }

        return {
            count
        }
    }
}
</script>
